import React, {useEffect, useRef} from 'react';

const TextareaInput = ({
                           label,
                           name,
                           value,
                           onChange,
                           placeholder,
                           className = '',
                           maxRows = 100,
                           colspan = null,
                           required = false
                       }) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        // reset height -> pak nastavit podle scrollHeight
        textarea.style.height = 'auto';

        // výška jednoho řádku podle computed style
        const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10) || 20;
        const maxHeight = lineHeight * maxRows;

        textarea.style.height = Math.min(textarea.scrollHeight, maxHeight) + 'px';
    }, [value, maxRows]);

    return (
        <div className={`FormInput Textarea ${colspan ? `col-span-${colspan}` : ''}`}>
            {label && <label className={`${required ? 'required' : ''}`} htmlFor={name}>{label}</label>}
            <textarea
                ref={textareaRef}
                id={name}
                name={name}
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                className={`appearance-none relative block w-full px-3 py-2 border border-gray-300 
          placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 
          focus:border-indigo-500 focus:z-10 sm:text-sm resize-none ${className}`}
            />
        </div>
    );
};

export default TextareaInput;
